import request from '@/utils/request'
const BASE_URL = '/SectionSetting'


export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: { id }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    },
    getMaxNumber(termId, gradeId, sectionType) {
        return request({
            url: BASE_URL + '/GetMaxNumber',
            method: 'get',
            params: { termId, gradeId, sectionType }
        })
    },
    getNowNumber(termId, sectionType) {
        return request({
            url: BASE_URL + '/GetNowNumber',
            method: 'get',
            params: { termId, sectionType }
        })
    },
    addMorning(data) {
        return request({
            url: BASE_URL + '/AddMorning',
            method: 'post',
            data
        })
    },
    deleteMorning(id) {
        return request({
            url: BASE_URL + '/DeleteMorning',
            method: 'get',
            params: { id }
        })
    },
    addNight(data) {
        return request({
            url: BASE_URL + '/AddNight',
            method: 'post',
            data
        })
    },
    deleteNight(id) {
        return request({
            url: BASE_URL + '/DeleteNight',
            method: 'get',
            params: { id }
        })
    },
    //复制节次
    copy(termId, copyTermId) {
        return request({
            url: BASE_URL + '/Copy',
            method: 'get',
            params: { termId, copyTermId }
        })
    },
}